import type { CodeTypeTCC } from "./codeTypes";

export interface Code {
  Code: string;
  CodeType: CodeTypeTCC;
}

// should be type CodeInfoKey = `${string}:${string}`; but it doesn't work in current version of TS
export type CodeInfoKey = string;

type CodeInfo = string | null; // null = error, undefined = not loaded yet

export type CodesInfo = Record<string, CodeInfo>;

export function emptyCodesInfoState(): CodesInfo {
  return {};
}

export function getCodeInfoKey(codeType: string, code: string): CodeInfoKey {
  return `${code}:${codeType}`;
}
